import { JsonProperty, JsonObject } from "json2typescript";

@JsonObject("ProposalParticipant")
export class ProposalParticipant {
    @JsonProperty("id", String)
    public id: string = "";

    @JsonProperty("first_name", String)
    public first_name: string = "" ;
    
    @JsonProperty("last_name", String)
    public last_name: string = "";
}

@JsonObject("ProposalProjectItem")
export class ProposalProjectItem {

    @JsonProperty("id", String)
    public id: string = "";

    @JsonProperty("begin_date", Number)
    public begin_date: number = 0;

    @JsonProperty("end_date", Number)
    public end_date: number = 0;

    @JsonProperty("budget", Number)
    public budget: number = 0;

    @JsonProperty("participants", [])
    public participants: ProposalParticipant[] = [];
}

@JsonObject("ProposalListItem")
export class ProposalListItem {

    @JsonProperty("proposal_id", Number)
    public proposal_id: number = 0;

    @JsonProperty("title", String)
    public title: string = "";
    
    @JsonProperty("description", String)
    public description: string = "";
    
    @JsonProperty("agency", String)
    public agency: string = "";

    @JsonProperty("begin_date", String)
    public begin_date: string = "";

    @JsonProperty("end_date", String)
    public end_date: string = "";
        
    @JsonProperty("projects", [])
    public projects: ProposalProjectItem[] = [];

}


// WEBPACK FOOTER //
// ./src/models/ProposalListItem.ts